const AUTH_KEY = 'mengerler_auth_role';

export const ADMIN_PASSWORD = '1111';

export function getStoredRole() {
  try {
    const role = localStorage.getItem(AUTH_KEY);
    return role === 'admin' || role === 'user' ? role : null;
  } catch {
    return null;
  }
}

export function setStoredRole(role) {
  try {
    localStorage.setItem(AUTH_KEY, role);
  } catch {
    /* ignore */
  }
}

export function clearStoredRole() {
  try {
    localStorage.removeItem(AUTH_KEY);
  } catch {
    /* ignore */
  }
}

export function isAdminRole(role) {
  return role === 'admin';
}

/** Masks phone for normal users: 5557122428 → 555 *** ** 28 */
export function maskPhoneNumber(phone) {
  if (!phone || typeof phone !== 'string') return '—';
  const trimmed = phone.trim();
  if (!/\d/.test(trimmed)) return trimmed;

  const countryMatch = trimmed.match(/^(\+\d{1,3})\s*/);
  const country = countryMatch ? countryMatch[1] : '';
  const rest = country ? trimmed.slice(countryMatch[0].length) : trimmed;
  const digits = rest.replace(/\D/g, '');

  if (digits.length < 4) return country ? `${country} ***` : '***';

  const start = digits.slice(0, 3);
  const end = digits.slice(-2);
  const masked = `${start} *** ** ${end}`;
  return country ? `${country} ${masked}` : masked;
}
